var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBellNotification = function SvgBellNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    className: "bell-notification_svg__svg-icon",
    viewBox: "0 0 64 64"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11.636 24.364C11.636 13.117 20.753 4 32 4s20.363 9.117 20.363 20.364v12.052l7.64 13.402H3.997l7.639-13.402zM26.908 60H37.09v-5.09H26.908z",
    clipRule: "evenodd"
  })));
};
export { SvgBellNotification as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgNjQgNjQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIgY2xhc3M9InN2Zy1pY29uIj48cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTExLjYzNTkgMjQuMzYzNkMxMS42MzU5IDEzLjExNzEgMjAuNzUzIDQgMzEuOTk5NiA0QzQzLjI0NTkgNCA1Mi4zNjMyIDEzLjExNzEgNTIuMzYzMiAyNC4zNjM2VjM2LjQxNjRMNjAuMDAzMSA0OS44MTgySDMuOTk2ODNMMTEuNjM1OSAzNi40MTY0VjI0LjM2MzZaTTI2LjkwODQgNjBIMzcuMDkwMlY1NC45MDkxSDI2LjkwODRWNjBaIiBmaWxsPSJjdXJyZW50Q29sb3IiLz48L3N2Zz4=";